/**
 * @file Highlights Actions.
 */

export const SET_ENTITY = 'highlights/SET_ENTITY';
export const TOGGLE_IDENTITY = 'highlights/TOGGLE_IDENTITY';
export const SET_IDENTITY = 'highlights/SET_IDENTITY';
export const UPDATE_FILTER = 'highlights/UPDATE_FILTER';

export const setEntity = entity => {
  return { type: SET_ENTITY, entity };
};

export const toggleIdentity = identityId => {
  return { type: TOGGLE_IDENTITY, identityId };
};

export const setIdentity = identityId => {
  return { type: SET_IDENTITY, identityId };
};

export const updateFilter = filter => {
  return { type: UPDATE_FILTER, filter };
};
